import httpRequest from "services/httpRequest";

const prefix = "/api/customer";

export const getCustomerPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: params,
  });
  if (result?.data) {
    return result.data;
  }
  return {};
};

export const getCustomerPageAllSearchKey = async params => {
  const result = await httpRequest({
    url: `${prefix}/search-key-all`,
    method: "GET",
    params: params,
  });
  if (result?.data) {
    return result.data;
  }
  return {};
};

export const onGetCustomerDetail = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "GET",
    params: { broadcastListId: params.broadcastListId || "" },
  });
};

export const onCreateCustomer = async body => {
  return await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: body,
    successMessage: "toast.create_success",
  });
};

export const onAddCustomersToBroadcastList = async body => {
  const data = {
    broadcastListId: body.broadcastListId,
    createCustomerAndContactRequests: body.createCustomerAndContactRequests,
  };
  if (body.workspaceId) {
    data["workspaceId"] = body.workspaceId;
  }
  if (body.isImport) {
    return await httpRequest({
      url: `${prefix}/import`,
      method: "POST",
      data: data,
      successMessage: "toast.import_success",
    });
  } else {
    return await httpRequest({
      url: `${prefix}/import`,
      method: "POST",
      data: data,
      // successMessage: "toast.create_success",
    });
  }
};

export const onUpdateCustomer = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params.data,
    params: { broadcastListId: params.broadcastListId || "" },
    successMessage: "toast.update_success",
  });
};

export const onDeleteCustomer = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "DELETE",
    params: { broadcastListId: params.broadcastListId || "" },
    successMessage: "toast.delete_success",
  });
};

export const onExportCSVCustomers = async params => {
  const request = {
    workspace_id: params.workspaceId,
  };
  const result = await httpRequest({
    url: `${prefix}/export-csv/${params.id}`,
    method: "GET",
    params: request,
    successMessage: "toast.download_success",
  });
  return result;
};

export const onGetAllCustomers = async () => {
  const result = await httpRequest({
    url: `${prefix}/all`,
    method: "GET",
  });
  return result;
};

export const onGetAllCustomerNotInBroadcastList = async params => {
  const result = await httpRequest({
    url: `${prefix}/all-not-in-broadcast-list`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onUpdateOptInCustomer = async params => {
  const result = await httpRequest({
    url: `${prefix}/optin/${params.id}`,
    method: "PUT",
    data: params.data,
  });
  return result;
};
